module.exports = __webpack_public_path__ + "static/media/subtraction_shape.1c3dfcba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Svg/subtraction_shape.svg
// module id = 1364
// module chunks = 0